import React from 'react';

import LinkList from '../LinkList';
import type { LinkListTertiaryItemProps } from '../LinkList/Tertiary';

import './style.scss';

export interface QuicklinksProps {
  links: Omit<LinkListTertiaryItemProps, 'iconName'>[];
}

const Quicklinks: React.FC<QuicklinksProps> = (props) => {
  const { links } = props;

  return (
    <div className="Quicklinks">
      <LinkList>
        {links.map(({ link, title }) => (
          <LinkList.TertiaryItem
            key={`quicklink:${title}`}
            link={link}
            title={title}
            iconName="chevron_down"
          />
        ))}
      </LinkList>
    </div>
  );
};

export default Quicklinks;
